import React, { useRef } from 'react';
import { Canvas, useFrame } from '@react-three/fiber';
import { Float, MeshDistortMaterial, Environment, ContactShadows } from '@react-three/drei';
import * as THREE from 'three';

const AnimatedBlob = () => {
  const meshRef = useRef<THREE.Mesh>(null);
  
  useFrame((state) => {
    if (meshRef.current) {
      meshRef.current.rotation.x = state.clock.elapsedTime * 0.2;
      meshRef.current.rotation.y = state.clock.elapsedTime * 0.3;
    }
  });

  return (
    <Float speed={2} rotationIntensity={1} floatIntensity={2}>
      <mesh ref={meshRef} scale={1.5}>
        <icosahedronGeometry args={[1, 64]} />
        <MeshDistortMaterial 
          color="#a855f7" 
          emissive="#ec4899"
          envMapIntensity={1} 
          clearcoat={1} 
          clearcoatRoughness={0.1} 
          metalness={0.1} 
          roughness={0.2}
          distort={0.4} 
          speed={2} 
        />
      </mesh>
    </Float>
  );
};

const FloatingShapes = () => {
  return (
    <group>
      <Float speed={1.5} rotationIntensity={2} floatIntensity={2} position={[-3, 1, -2]}>
        <mesh>
          <torusGeometry args={[0.5, 0.2, 16, 32]} />
          <meshStandardMaterial color="#06b6d4" roughness={0.1} metalness={0.8} />
        </mesh>
      </Float>
      <Float speed={2.5} rotationIntensity={1.5} floatIntensity={1.5} position={[3, -1, -1]}>
        <mesh>
          <octahedronGeometry args={[0.6]} />
          <meshStandardMaterial color="#f59e0b" roughness={0.2} metalness={0.5} />
        </mesh>
      </Float>
    </group>
  );
};

export default function Scene3D() {
  return (
    <div className="absolute inset-0 z-0 pointer-events-none opacity-60">
      <Canvas camera={{ position: [0, 0, 5], fov: 45 }}>
        <ambientLight intensity={0.5} />
        <directionalLight position={[10, 10, 5]} intensity={1} />
        <directionalLight position={[-10, -10, -5]} intensity={0.5} color="#06b6d4" />
        <AnimatedBlob />
        <FloatingShapes />
        <Environment preset="city" />
        <ContactShadows position={[0, -2.5, 0]} opacity={0.5} scale={10} blur={2} far={4} />
      </Canvas>
    </div>
  );
}
